(() => {
  const ROOT_SELECTOR = '[data-unbegun-preorder]';

  function formFor(root) {
    return root?.closest('form[data-product-form], form[action*="/cart/add"]');
  }

  function modalFor(root) {
    return root?.querySelector('[data-preorder-modal]');
  }

  function openModal(root) {
    const modal = modalFor(root);
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('unbegun-preorder-open');
    window.setTimeout(() => modal.querySelector('[data-preorder-confirm]')?.focus(), 20);
  }

  function closeModal(root, { returnFocus = true } = {}) {
    const modal = modalFor(root);
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('unbegun-preorder-open');
    if (returnFocus) formFor(root)?.querySelector('[data-add-button]')?.focus();
  }

  function hasRecentConfirmation(root) {
    return Number(root?.dataset.confirmedUntil || 0) > Date.now();
  }

  function intercept(event, root) {
    if (hasRecentConfirmation(root)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openModal(root);
  }

  function confirm(root) {
    closeModal(root, { returnFocus: false });

    root.dataset.confirmedUntil = String(Date.now() + 1500);

    const form = formFor(root);
    if (!form) return;

    const button = form.querySelector('[data-add-button]');

    if (button) {
      button.click();
    } else {
      form.requestSubmit();
    }
  }

  function init(root) {
    if (root.dataset.preorderReady === 'true') return;
    root.dataset.preorderReady = 'true';

    const form = formFor(root);
    if (!form) return;

    const button = form.querySelector('[data-add-button]');

    button?.addEventListener(
      'click',
      (event) => intercept(event, root),
      true
    );

    form.addEventListener(
      'submit',
      (event) => intercept(event, root),
      true
    );

    root
      .querySelector('[data-preorder-confirm]')
      ?.addEventListener('click', () => confirm(root));

    root
      .querySelectorAll('[data-preorder-cancel]')
      .forEach((element) =>
        element.addEventListener('click', () => closeModal(root))
      );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal(root);
      }
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.UnbegunPreorder = {
    appendToPayload(payload) {
      return payload;
    }
  };
})();